// Matches the existing superAdminApi.js base URL, session and CSRF conventions.
import { getSuperAdminCsrf } from './superAdminApi';

const BASE = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
const ROOT = `${BASE}/api/superadmin/billing`;

async function request(path, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const headers = { Accept: 'application/json', ...(options.body ? { 'Content-Type': 'application/json' } : {}), ...options.headers };
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    const { csrfToken } = await getSuperAdminCsrf();
    headers['X-CSRFToken'] = csrfToken;
  }
  const response = await fetch(`${ROOT}${path}`, { ...options, credentials: 'include', headers });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = data.detail;
    const message = Array.isArray(detail) ? detail.join(' ') : typeof detail === 'string' ? detail : `Request failed (${response.status})`;
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }
  return data;
}

export const billingOverview = () => request('/overview/');
export const listSubscriptions = () => request('/subscriptions/');
export const createSubscription = data => request('/subscriptions/', { method: 'POST', body: JSON.stringify(data) });
export const updateSubscription = (id, data) => request(`/subscriptions/${id}/`, { method: 'PATCH', body: JSON.stringify(data) });
export const generateSubscriptionInvoice = id => request(`/subscriptions/${id}/generate-invoice/`, { method: 'POST' });
export const listInvoices = (restaurantId = '') => request(`/invoices/${restaurantId ? `?restaurant_id=${encodeURIComponent(restaurantId)}` : ''}`);
export const listInvoicePayments = id => request(`/invoices/${id}/payments/`);
export const recordInvoicePayment = (id, data) => request(`/invoices/${id}/payments/`, { method: 'POST', body: JSON.stringify(data) });
